import styled from 'styled-components'

export const ContentDropdown = styled.div`
  div[role='option']:last-child {
    border: none;
  }
`
